// extracted by mini-css-extract-plugin
export default {"root":"Popup_root__ScG7w","popup":"Popup_popup__6Hq4x","body":"Popup_body__82L-C","close":"Popup_close__iCfT5"};